import { styled, Typography } from '@mui/material';

export const StyledTypography = styled(Typography)<{
  fontSize?: string;
  fontWeight?: string;
  color?: string;
}>(
  ({ fontSize, fontWeight, color }) => `
    font-size: ${fontSize || '14px'};
    font-weight: ${fontWeight || '500'};
    color: ${color || 'inherit'};
    margin-left: 4px;
    margin-top: 2px;
    padding-right: 10px
  `,
);

export const StyledWrapper = styled('span')<{
  iconSize?: string;
  iconColor?: string;
}>(
  ({ iconSize, iconColor }) => `
    display: flex;
    align-items: center;

    svg {
      width: ${iconSize || '24px'};
      height: ${iconSize || '24px'};
      color: ${iconColor || 'inherit'};
    }
  `,
);
